import type { AkamaiImageQualityEnum } from '@inter-ikea-kompis/enums';
const AKAMAI_SIZES: {
	[key: string]: string;
} = {
	'40': 'xxu',
	'80': 'xu',
	'160': 'u',
	'300': 'xxxs',
	'400': 'xxs',
	'500': 'xs',
	'600': 's',
	'700': 'm',
	'750': 'l',
	'900': 'xl',
	'1100': 'xxl',
	'1400': 'xxxl',
	'1600': 'sg',
	'2000': 'g',
	'3000': 'xg',
	'4000': 'xxg'
};

const SIZE_NUMBERS: number[] = Object.keys(AKAMAI_SIZES).map((size) => parseInt(size));

/**
 * Utility for calculating image src.
 */
export default class ImageUtility {
	/**
	 * Returns Akamai URL for an image.
	 *
	 * @param url URL of image.
	 * @param width Width in pixels.
	 * @param [quality] Quality.
	 * @returns Akamai URL.
	 */
	public static getAkamaiImageUrl(
		url: string,
		width: number,
		quality?: AkamaiImageQualityEnum
	): string {
		return url + this.getAkamaiQueryString(width, quality);
	}

	/**
	 * Returns an Akamai query string based on size.
	 *
	 * @param width Width of the image in px.
	 * @param [quality] Quality.
	 * @returns Query string.
	 */
	private static getAkamaiQueryString(width: number, quality?: AkamaiImageQualityEnum): string {
		return `?f=${this.getAkamaiSize(width)}${quality ? `&q=${quality}` : ''}`;
	}

	/**
	 * Get Akamai formatted size.
	 *
	 * @param width Image width.
	 * @returns Size.
	 */
	private static getAkamaiSize(width: number): string {
		for (const akamaiSize of SIZE_NUMBERS) {
			if (width <= akamaiSize) {
				return AKAMAI_SIZES[akamaiSize.toString()];
			}
		}

		return AKAMAI_SIZES[SIZE_NUMBERS[SIZE_NUMBERS.length - 1].toString()];
	}
}
